import React, { useEffect } from "react";
import { connect } from "react-redux";

import toast, { Toaster } from "react-hot-toast";
import {
  LeaveAndWFHListPayloadType,
  LeaveAndWFHStatusPayload,
} from "../../../../commonTypes/stcoToolsType";
import { LeaveAndUpcomingHistoryListType } from "../../../../redux/stcoTools/stcoToolsType";
import {
  LEAVE_HISTORYT_HEADERS,
  LEAVE_PENDING_HEADERS,
} from "../../../../constant/tableHeadersConstants/stcoTools/leaveAndWFHTableHeader";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import {
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../commons";
import LeavesPendingApprovalTable from "../LeavePendingApproval/LeavesPendingApprovalTable";
import {
  getLeaveAndWFHListAction,
  leaveAndWFHApprovedStatusAction,
  leaveAndWFHRejectStatusAction,
  resetLeaveAndWFHList,
  resetStcoToolsError,
  resetStcoToolsMessage,
  resetStcoToolsStatusCode,
  resetStcoToolsSuccess,
  resetUpcomingLeaveList,
} from "../../../../redux/stcoTools";
import { resetSession } from "../../../../redux/auth";
import { RootState } from "../../../../redux/rootReducers";
import { useLocation } from "react-router-dom";

type AppProps = {
  dispatchLeaveAndHistoryListAction: (data: LeaveAndWFHListPayloadType) => void;
  leaveAndWFHHistoryList: [] | LeaveAndUpcomingHistoryListType[];
  token: string | null;
  fetching: boolean;
  dispatchLeaveAndWFHApprovedAction: (data: LeaveAndWFHStatusPayload) => void;
  dispatchLeaveAndWFHRejectedAction: (data: LeaveAndWFHStatusPayload) => void;
  success: number | null;
  error: string | null;
  message: string | null;
  statusCode: number | null;
  dispatchResetStcoToolsSuccess: () => void;
  dispatchResetStcoToolsError: () => void;
  dispatchResetStcoToolsMessage: () => void;
  dispatchResetStcoToolsStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetUpcomingLeaveAndWFHList: () => void;
  dispatchResetResetLeaveHistoryList: () => void;
  history: any;
};
const PendingLeaves = ({
  leaveAndWFHHistoryList,
  token,
  fetching,
  dispatchLeaveAndHistoryListAction,
  dispatchLeaveAndWFHApprovedAction,
  dispatchLeaveAndWFHRejectedAction,
  success,
  error,
  message,
  statusCode,
  dispatchResetStcoToolsSuccess,
  dispatchResetStcoToolsError,
  dispatchResetStcoToolsMessage,
  dispatchResetStcoToolsStatusCode,
  dispatchResetSession,
  dispatchResetUpcomingLeaveAndWFHList,
  dispatchResetResetLeaveHistoryList,
  history,
}: AppProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    dispatchResetResetLeaveHistoryList();
    window.scrollTo(0, 0);
    if (token) {
      let finalData = {
        token,
        user_type: "manager",
        status: "1",
        type: pathname === "/my-space/pending-wfh" ? "wfh" : "leave",
      };
      dispatchLeaveAndHistoryListAction(finalData);
    }
  }, []);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetStcoToolsError();
            }}
          />
        );
      }
    } else if (success === 1) {
      if (
        message &&
        message === "Your leave request has been approved successfully."
      ) {
        toast.success("Your leave request has been approved successfully.", {
          duration: 3000,
        });
        dispatchResetStcoToolsSuccess();
        dispatchResetStcoToolsMessage();

        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "manager",
            status: "1",
          };
          dispatchLeaveAndHistoryListAction(finalData);
        }
      } else if (
        message &&
        message === "Your leave request has been rejected."
      ) {
        toast.success("Your leave request has been rejected.", {
          duration: 3000,
        });
        dispatchResetStcoToolsSuccess();
        dispatchResetStcoToolsMessage();

        if (token) {
          dispatchResetUpcomingLeaveAndWFHList();
          let finalData = {
            token,
            user_type: "manager",
            status: "1",
          };
          dispatchLeaveAndHistoryListAction(finalData);
        }
      }
    }
  };
  return (
    <>
      {fetching ? (
        <TableLoader Rows={10} ColumnPerRow={6} />
      ) : leaveAndWFHHistoryList?.length ? (
        <LeavesPendingApprovalTable
          tableHeader={LEAVE_PENDING_HEADERS}
          data={leaveAndWFHHistoryList}
          history={history}
        />
      ) : (
        !fetching && (
          <div className="p-5 mt-3">
            <EmptyListPage title="No List Found!" imageWidth="30%" />
          </div>
        )
      )}

      {handleErrorModal()}
      <Toaster />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchLeaveAndHistoryListAction: (data: LeaveAndWFHListPayloadType) =>
    dispatch(getLeaveAndWFHListAction(data)),

  dispatchLeaveAndWFHApprovedAction: (data: LeaveAndWFHStatusPayload) =>
    dispatch(leaveAndWFHApprovedStatusAction(data)),

  dispatchLeaveAndWFHRejectedAction: (data: LeaveAndWFHStatusPayload) =>
    dispatch(leaveAndWFHRejectStatusAction(data)),

  dispatchResetSession: () => dispatch(resetSession()),

  dispatchResetStcoToolsSuccess: () => dispatch(resetStcoToolsSuccess()),
  dispatchResetStcoToolsError: () => dispatch(resetStcoToolsError()),
  dispatchResetStcoToolsMessage: () => dispatch(resetStcoToolsMessage()),
  dispatchResetStcoToolsStatusCode: () => dispatch(resetStcoToolsStatusCode()),
  dispatchResetUpcomingLeaveAndWFHList: () =>
    dispatch(resetUpcomingLeaveList()),
  dispatchResetResetLeaveHistoryList: () => dispatch(resetLeaveAndWFHList()),
});

const mapStateToProps = (state: RootState) => ({
  leaveAndWFHHistoryList: state.stcoTools.leaveAndWFHHistoryList,
  token: state.auth.token,
  fetching: state.stcoTools.fetching,
  success: state.stcoTools.success,
  message: state.stcoTools.message,
  error: state.stcoTools.error,
  statusCode: state.stcoTools.statusCode,
});
export default connect(mapStateToProps, mapDispatchToProps)(PendingLeaves);
